import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { API, auth, err } from './invoices/invoiceApi';
import { ActiveSender } from './email/ActiveSender';
import { DraftForm } from './email/DraftForm';
import { ApiKeyField } from './email/ApiKeyField';
import { Checklist } from './email/Checklist';
import { TestControls, ActivatePanel } from './email/TestAndActivate';

export default function EmailSettingsTab({ token }) {
  const [d, setD] = useState(null);
  const call = useCallback(async (method, path, body, ok) => {
    try {
      const r = await axios({ method, url: `${API}/admin/email-settings${path}`, data: body, ...auth(token) });
      setD(r.data); if (ok) toast.success(ok); return true;
    } catch (e) { toast.error(err(e, 'Request failed')); return false; }
  }, [token]);
  useEffect(() => { call('get', '?refresh=true'); }, [call]);
  if (!d) return <p className="text-sm text-neutral-500" data-testid="email-settings-loading">Loading email settings…</p>;
  return (
    <div className="space-y-6 max-w-6xl" data-testid="email-settings-tab">
      <h2 className="text-lg font-semibold flex items-center gap-2"><Mail className="w-5 h-5" />Email Settings</h2>
      <ActiveSender d={d} onRollback={() => call('post', '/rollback', { confirm: true }, 'Rolled back to the previous sender')} />
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-white border rounded-lg p-5 space-y-5">
          <p className="font-semibold">{d.setup_required ? 'New sender' : 'New / pending sender'}</p>
          <DraftForm draft={d.draft} setupRequired={d.setup_required} onSave={(f) => call('put', '', f, 'Draft saved')} />
          <ApiKeyField draft={d.draft} onSave={(k) => call('put', '/key', { api_key: k }, 'API key saved')} />
        </div>
        <div className="bg-white border rounded-lg p-5 space-y-4 self-start">
          <div className="flex items-center justify-between"><p className="font-semibold">Readiness checks</p>
            <Button size="sm" variant="ghost" onClick={() => call('get', '?refresh=true')} data-testid="email-refresh"><RefreshCw className="w-4 h-4" /></Button></div>
          {d.draft_is_active && <p className="text-xs text-neutral-500" data-testid="email-checks-active-note">These settings are already live. The checks below only apply when you change the sender, key or Reply-To.</p>}
          <Checklist d={d} />
          <TestControls d={d} call={call} />
        </div>
      </div>
      <div className="bg-white border rounded-lg p-5 space-y-3" data-testid="email-switch-panel">
        <ActivatePanel d={d} call={call} />
        {d.recent_failures?.length > 0 && <div className="text-xs text-red-700" data-testid="email-failures">Recent failed sends: {d.recent_failures.map((f) => `${f.at.slice(0, 16)} ${f.to} (${f.error})`).join(' · ')}</div>}
      </div>
    </div>
  );
}
